import { render, staticRenderFns } from "./directInvest_Invest.vue?vue&type=template&id=56da19ce&scoped=true"
import script from "./directInvest_Invest.vue?vue&type=script&lang=js"
export * from "./directInvest_Invest.vue?vue&type=script&lang=js"
import style0 from "./directInvest_Invest.vue?vue&type=style&index=0&id=56da19ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da19ce",
  null
  
)

export default component.exports